import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="pt-32 pb-24 border-b border-stone-300" data-id="element-1093">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1094">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-1095">
          {/* Left: Editorial headline */}
          <div className="lg:col-span-7" data-id="element-1096">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6
          }} data-id="element-1097">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-6" data-id="element-1098">
                Group Travel Infrastructure
              </p>

              <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl tracking-tight leading-[1.1] text-stone-900 mb-8" data-id="element-1099">
                Instant quotes.
                <br data-id="element-1100" />
                Direct pricing.
                <br data-id="element-1101" />
                Zero leakage.
              </h1>

              <p className="text-lg text-stone-600 leading-relaxed max-w-xl mb-10" data-id="element-1102">
                The infrastructure layer for group travel distribution. Replace
                email chains with instant quoting. Eliminate wholesale margin
                capture. Own your revenue.
              </p>

              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1103">
                <button onClick={() => window.location.href = '/app'} className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 text-sm font-medium transition-colors" data-id="element-1104">
                  Try the Demo
                  <ArrowRight className="w-4 h-4" data-id="element-1105" />
                </button>
                <button onClick={() => scrollTo('proof')} className="flex items-center justify-center gap-2 border border-stone-300 hover:border-stone-400 text-stone-700 px-6 py-3 text-sm font-medium transition-colors" data-id="element-1106">
                  See the Proof
                </button>
              </div>
            </motion.div>
          </div>

          {/* Right: Metrics grid */}
          <div className="lg:col-span-5" data-id="element-1107">
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="border border-stone-300 h-full" data-id="element-1108">
              <div className="border-b border-stone-300 p-6" data-id="element-1109">
                <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-1110">
                  Estimated Impact
                </p>
                <div className="font-mono text-5xl text-stone-900 mb-2" data-id="element-1111">
                  $6.0M<span className="text-red-600" data-id="element-1112">+</span>
                </div>
                <p className="text-sm text-stone-500" data-id="element-1113">
                  Estimated annual savings per resort group
                </p>
              </div>

              <div className="border-b border-stone-300 p-6" data-id="element-1114">
                <div className="font-mono text-5xl text-stone-900 mb-2" data-id="element-1115">
                  3<span className="text-red-600" data-id="element-1116">×</span>
                </div>
                <p className="text-sm text-stone-500" data-id="element-1117">
                  Faster quoting velocity
                </p>
              </div>

              <div className="p-6" data-id="element-1118">
                <div className="font-mono text-5xl text-stone-900 mb-2" data-id="element-1119">
                  &lt;1<span className="text-red-600 text-sm ml-1" data-id="element-1120">min</span>
                </div>
                <p className="text-sm text-stone-500" data-id="element-1121">
                  Quote response time (from 48–72 hrs)
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}